import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
    state: () => {
        return {
            opfw:               window.OptimizeFlow,
            hasWorkflows:       window.OptimizeFlow.has_workflows,
            workflowCount:      window.OptimizeFlow.workflow_count,
            slIsConnected:      window.OptimizeFlow.sl_is_connected,
            slLicenseIsValid:   window.OptimizeFlow.sl_license_is_valid,
            maxLogItems:        window.OptimizeFlow.max_log_items,
            ajaxUrl:            window.OptimizeFlow.ajax_url,
            restUrl:            window.OptimizeFlow.rest_url,
            assetsUrl:          window.OptimizeFlow.assets_url,
            imgUrl:             window.OptimizeFlow.img_url,
            config:             window.OptimizeFlow.config,
            developer:          window.OptimizeFlow.sl_role === 'admin',
            debug:              window.OptimizeFlow.debug,
        }
    },
    actions: {
        increaseWorkflowCount() {
            this.workflowCount++
            this.setWorkflowCount(this.workflowCount)
        },

        decreaseWorkflowCount() {
            this.workflowCount--
            this.setWorkflowCount(this.workflowCount)
        },

        setWorkflowCount(count) {
            this.workflowCount = count

            if (this.workflowCount > 0) {
                this.hasWorkflows = true
            } else {
                this.hasWorkflows = false
            }
        }
    }
})
